const typeSurveyRouter = [
    {
        path:'',
        name:'typeSurvey-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/typeSurvey/index.vue'),
        children:[
            {
                path:'',
                name:'typeSurvey-empty',
                component: () => import(/* webpackChunkName: "about" */ '../components/empty.vue'),
                props: { message: '請點選左側列表檢視型質測量紀錄，或者新增型質測量紀錄' }
            },
            {
                path:'create/:id',
                name:'typeSurvey-create',
                component: () => import(/* webpackChunkName: "about" */ '../views/typeSurvey/create.vue'),
            },
            {
                path:'detail/:id',
                name:'typeSurvey-detail',
                component: () => import(/* webpackChunkName: "about" */ '../views/typeSurvey/detail.vue'),
            },{
                path:'edit/:id',
                name:'typeSurvey-edit',
                component: () => import(/* webpackChunkName: "about" */ '../views/typeSurvey/edit.vue'),
            },
        ]
    },
  ]
  export default typeSurveyRouter

  